// @flow
import React, { Children, type Node } from 'react';
import classnames from 'classnames';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';

import { themes } from './Fieldset.themes';

type FieldsetProps = {
  children: Node,
  className?: string,
  description?: string,
  iconName?: IconName,
  legend?: string,
  subLegend?: string,
  theme?: string,
};

export function Fieldset(props: FieldsetProps) {
  const {
    children,
    className,
    description,
    iconName,
    legend,
    subLegend,
    theme = 'default',
  } = props;

  if (!Children.count(children)) return null;

  const hasLegend = !!iconName || !!legend || !!subLegend;

  const {
    thDescription,
    thHead,
    thIcon,
    thIconSize,
    thLegend,
    thLegends,
    thLegendsInner,
    thRoot,
    thSmall,
  } = themes[theme];

  return (
    <fieldset className={classnames(className, thRoot)}>
      {hasLegend && (
        <legend className={thLegends}>
          <div className={thHead}>
            <Icon className={thIcon} name={iconName} width={thIconSize} />
            {(legend || subLegend) && (
              <div className={thLegendsInner}>
                <div className={thLegend} data-testid="Fieldset-legend">
                  {legend}
                </div>
                {subLegend && <small className={thSmall}>{subLegend}</small>}
              </div>
            )}
          </div>
        </legend>
      )}
      <Text className={thDescription} text={description} />
      {children}
    </fieldset>
  );
}
